const DARK_MODE = {
  LOCAL_STORAGE_KEY: 'darkMode',
};

export { DARK_MODE };
